module.exports = __webpack_public_path__ + "static/media/Habitual.05a5e7a4.png";